import React, { useState } from 'react';
import Swal from 'sweetalert2';

const LoyaltyCheck = ({ businessId, token }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [checking, setChecking] = useState(false);
    const [loyaltyData, setLoyaltyData] = useState(null);
    const [showResult, setShowResult] = useState(false);

    const formatPhoneNumber = (phone) => {
        let cleaned = phone.replace(/\D/g, '');
        if (cleaned.startsWith('0')) {
            cleaned = cleaned.substring(1);
        }
        if (!cleaned.startsWith('92')) {
            cleaned = '92' + cleaned;
        }
        return '+' + cleaned;
    };

    const checkLoyalty = async () => {
        if (!phoneNumber) {
            Swal.fire({
                icon: 'warning',
                title: 'Phone Required',
                text: 'Please enter a customer phone number'
            });
            return;
        }

        setChecking(true);
        setLoyaltyData(null);
        setShowResult(false);

        try {
            const formattedPhone = formatPhoneNumber(phoneNumber);
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/loyalty/available?business_id=${businessId}&phone_number=${encodeURIComponent(formattedPhone)}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                throw new Error('Failed to fetch loyalty data');
            }

            const data = await response.json();
            
            if (data.success) {
                setLoyaltyData(data);
                setShowResult(true);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Not Found',
                    text: 'No loyalty data found for this customer'
                });
            }
        } catch (error) {
            console.error('Error checking loyalty:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to check loyalty points'
            });
        } finally {
            setChecking(false);
        }
    };

    return (
        <div className="card">
            <div className="card-body">
                <h4 className="header-title m-t-0 m-b-30 text-center">Check Referral Points</h4>
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <div className="form-group text-center">
                            <label className="control-label">Enter Customer Phone Number</label>
                            <div className="input-group">
                                <input
                                    type="tel"
                                    className="form-control text-center"
                                    placeholder="Enter Phone Number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && checkLoyalty()}
                                />
                                <div className="input-group-append">
                                    <button 
                                        className="btn btn-primary"
                                        onClick={checkLoyalty}
                                        disabled={checking}
                                    >
                                        {checking ? (
                                            <><i className="fa fa-spinner fa-spin"></i> Checking...</>
                                        ) : (
                                            <><i className="fa fa-search"></i> Check Points</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        {showResult && loyaltyData && (
                            <div className="alert alert-info mt-4" style={{ backgroundColor: '#e8f4f8' }}>
                                <div className="row text-center">
                                    <div className="col-4">
                                        <h4 className="text-primary">{loyaltyData.total_earned_points || 0}</h4>
                                        <small>Earned</small>
                                    </div>
                                    <div className="col-4">
                                        <h4 className="text-danger">{loyaltyData.total_used_points || 0}</h4>
                                        <small>Used</small>
                                    </div>
                                    <div className="col-4">
                                        <h4 className="text-success">{loyaltyData.available_points || 0}</h4>
                                        <small>Available</small>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-12">
                                        <p><strong>📞 Phone:</strong> {loyaltyData.phone_number}</p>
                                        <p><strong>⚙️ Points Per Referral:</strong> {loyaltyData.loyalty_points_per_ref || 100}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoyaltyCheck;